import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { deviceBreakpoints } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import * as React from 'react';
import styled from 'styled-components';

import { ConversationScriptSnapshotIn } from '../../question-data-model/Script/_implementations/conversation-script.store';

export const Main = styled.div`
  .row-item {
    display: flex;
    margin-bottom: 16px;
    .txt-character {
      min-width: 88px;
      margin-right: 16px;

      font-size: 14px;
      font-weight: 600;
      line-height: 24px;
      color: ${colorsV2.gray100};
    }
    .txt-conversation-script {
      flex: 1;

      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      color: ${colorsV2.black100};
    }
    @media ${deviceBreakpoints.mobile} {
      flex-direction: column;
      .txt-character {
        margin-bottom: 8px;
      }
    }
  }
`;

interface TranscriptConversationContentProps {
  script: ConversationScriptSnapshotIn;
}

export const TranscriptConversationContent = (props: TranscriptConversationContentProps) => {
  const { script } = props;
  return (
    <Main>
      {script?.subtitle.map((item, index) => {
        const { text } = item.data;
        const findCharacter = (item as any).character;
        return (
          <div key={index} className="row-item">
            <div className="txt-character">{findCharacter?.name || '...'}: </div>
            <div className="txt-conversation-script">{text.trim()}</div>
          </div>
        );
      })}
    </Main>
  );
};
